/** @file cancelDragEvent: the window event name the Esc ladder fires when it cancels a drag. */

/** Panels that keep drag state of their own (viewport gizmo, timeline keys) listen for it and drop the drag. */
export const cancelDragEvent = 'pose3d:cancel-drag';
